import { useContext } from "react";
import { useSelector } from "react-redux";
import { WeeklyCalendar } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  calendar: WeeklyCalendar;
  editPersonalWeeklyCalendar(
    request: Boundaries["editPersonalWeeklyCalendar"]["request"],
  ): void;
}

function useEditPersonalWeeklyCalendar(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isEditPersonalWeeklyCalendarRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isEditPersonalWeeklyCalendarRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isEditPersonalWeeklyCalendarRequestFailure,
    ),
    calendar: useSelector(selector.getPersonalWeeklyCalendar),
    editPersonalWeeklyCalendar: core.editPersonalWeeklyCalendar,
  };
}

export { useEditPersonalWeeklyCalendar };
